import LocalizedStrings from "localized-strings";
import * as api from "@startapp/mistral-admin-api";

const strings = new LocalizedStrings({
	ptBR: {
		imageCase: {
			addImagePlaceholder: "Clique em adicionar para escolher uma imagem",
			addImagesPlaceholder: "Clique em adicionar para escolher algumas imagens",
			addImageBtn: "Adicionar",
		},
		logoutDialog: {
			title: "Logout",
			message: "Tem certeza que deseja sair?",
		},
		login: "Login",
		email: "Email",
		recoverPassword: {
			confimationDialog: {
				title: "Recuperção de Senha",
				message: "O email de recuperação de senha foi enviado com sucesso",
			},
			recoverPasswordButton: "Recuperar Senha",
			newPasswordButton: "Alterar Senha",
			backButton: "Voltar",
			email: "Email",
			newPassword: "Nova Senha",
			confirmNewPassword: "Confirme sua nova Senha",
		},
		// tslint:disable-next-line: no-hardcoded-credentials
		password: "Senha",
		recovery: "Recuperar Senha",
		components: {
			table: {
				create: "Criar",
				delete: "Deletar",
				edit: "Editar",
				editAndDelete: "Editar / Deletar",
			},
		},
		languages: {
			title: "Idiomas",
			ptBr: "Português",
			enUs: "Inglês",
			esEs: "Espanhol",
		},
		cancel: "Cancelar",
		confirm: "Confirmar",
		ok: "Ok",
		logo: {
			alt: "Logo Alt Aqui!",
			squared: "/logo_squared.png",
			horizontalWhite: "/logo_horizontal_white.png",
		},
		error: {
			default: "Houve um erro, tente novamente mais tarde.",
		},
		nav: {
			title: "Mistral",
			home: "Inicio",
			logout: "Sair",
		},
		home: {
			welcome: "Bem vindo ao dashboad do Mistral!",
		},
		hotel: {
			edit: {
				title: "Editar Hotel",
				sections: {
					metaTags: "Tags",
					data: "Dados",
					colors: "Cores",
					logos: "Logos",
					content: "Conteúdo",
					socialMedia: "Redes Sociais",
					address: "Endereço",
				},
				metaTagDialog: {
					title: "Adicionar Tag",
				},
				saved: "Alterações salvas com sucesso",
				fields: {
					name: "Nome",
					nick: "Nick",
					description: "Descrição",
					slogan: "Slogan",
					email: "Email",
					phone: "telefone",
					omnibeesId: "Id da Omnibees",
					colors: {
						primary: "Primária",
						secondary: "Secondária",
						tertiary: "Terciária (Opicional)",
						background: "Plano de fundo",
						textPrimary: "Texto",
						textSecondary: "Texto Secondaria (Opicional)",
						textTertiary: "Texto Terciária (Opicional)",
					},
					logos: {
						horizontal: "Logo Horizontal",
						squared: "Logo Quadrada",
						white: "Logo Branca (Opicional)",
					},
					socialMedia: {
						facebook: "Facebook",
						linkedin: "Linkedin",
						instagram: "Instagram",
					},
					address: {
						cep: "Cep",
						street: "Rua",
						neighborhood: "Bairro",
						number: "Numero",
						city: "Cidade",
						state: "Estado",
					},
					reserveDisponibility: {
						title: "Horário de disponibilidade das reservas",
						start: "Inicio",
						end: "Encerramento",
					},
					image: "Foto do hotel",
					videoUrl: "Url do video no Youtube",
					roomsDescription: "Texto de descrição dos quartos.",
					metaTag: "Tags",
				},
				buttons: {
					save: "Salvar",
					exit: "Sair",
				},
				errors: {
					imageNotFound: "É preciso inserir uma imagem",
					logoHorizontalNotFound: "É preciso inserir uma logo horizontal",
					logoSquaredNotFound: "É preciso inserir uma logo quadrada",
				},
			},
		},
		banner: {
			title: "Banners",
			table: {
				header: {
					picture: "Foto",
					nick: "Nick",
					title: "Title",
					description: "Descrição",
				},
				tableIsEmpty: "Não foi possivel encontrar mais banners",
			},
			deleteBannerDialog: {
				title: "Excluir Banner",
				message: "Deseja excluir o banner",
			},
			createOrEdit: {
				title: {
					new: "Novo Banner",
					edit: "Editar Banner",
				},
				fields : {
					nick: "Nick",
					title: "Titulo",
					description: "Descrição",
					url: "URL",
					imageTitle: "Imagem 1920x1200",
					mobileImageTitle: "Imagem para celular 800x800 (Opcional)",
				},
				sections: {
					data: "Dados",
					// tslint:disable-next-line: no-duplicate-string
					specifications: "Especificações",
				},
				buttons: {
					save: "Salvar",
					back: "Voltar",
				},
				errors: {
					imageNotFound: "É preciso de uma imagem para salvar o banner",
				},
			},
		},
		gallery: {
			title: "Galeria de fotos",
			table: {
				header: {
					picture: "Foto",
					nick: "Nick",
					title: "Title",
					description: "Descrição",
				},
				tableIsEmpty: "Não foi possivel encontrar mais fotos",
			},
			deleteGalleryDialog: {
				title: "Excluir Foto",
				message: "Deseja excluir a foto",
			},
			createOrEdit: {
				title: {
					new: "Nova Foto",
					edit: "Editar Foto",
				},
				fields : {
					nick: "Nick",
					title: "Titulo",
					description: "Descrição",
					url: "URL",
					imageTitle: "Imagem",
					mobileImageTitle: "Imagem para celular",
				},
				sections: {
					data: "Dados",
					// tslint:disable-next-line: no-duplicate-string
					specifications: "Especificações",
				},
				buttons: {
					save: "Salvar",
					back: "Voltar",
				},
				errors: {
					imageNotFound: "É preciso de uma imagem para salvar a foto",
				},
			},
		},
		offers: {
			title: "Promoções",
			table: {
				header: {
					picture: "Foto",
					name: "Nome",
					nick: "Nick",
					title: "Title",
					description: "Descrição",
				},
				tableIsEmpty: "Não foi possivel encontrar mais promoções",
			},
			deleteOfferDialog: {
				title: "Excluir Promoção",
				message: "Deseja excluir a promoção",
			},
			createOrEdit: {
				title: {
					new: "Nova Promoção",
					edit: "Editar Promoção",
				},
				fields : {
					nick: "Nick",
					name: "Nome",
					title: "Titulo",
					description: "Descrição",
					descriptionHtml: "Descrição Html (opicional)",
					url: "URL",
					imageTitle: "Imagem",
				},
				sections: {
					data: "Dados",
					specifications: "Especificações",
				},
				buttons: {
					save: "Salvar",
					back: "Voltar",
				},
				errors: {
					imageNotFound: "É preciso de uma imagem para salvar a promoção",
				},
			},
		},
		gastroPlaces: {
			title: "Bares e Restaurantes",
			table: {
				header: {
					picture: "Foto",
					type: "Tipo",
					name: "Nome",
					nick: "Nick",
					description: "Descrição",
				},
				tableIsEmpty: "Não foi possivel encontrar mais Bares ou Restauratens",
			},
			deleteGastroPlaceDialog: {
				title: "Excluir Bar/Restaurante",
				message: "Deseja excluir ",
			},
			createOrEdit: {
				title: {
					new: "Novo Bar/Restaurante",
					edit: "Editar Bar/Restaurante",
				},
				fields : {
					nick: "Nick",
					name: "Nome",
					description: "Descrição",
					url: "URL",
					imageTitle: "Imagem",
					type: "Tipo",
				},
				sections: {
					data: "Dados",
				},
				buttons: {
					save: "Salvar",
					back: "Voltar",
				},
				errors: {
					imageNotFound: "É preciso de uma imagem para salvar o Bar/Resturante",
				},
			},
		},
		rooms: {
			title: "Salas",
			table: {
				header: {
					picture: "Foto",
					name: "Nome",
					nick: "Nick",
					description: "Descrição",
				},
				tableIsEmpty: "Não foi possivel encontrar mais salas",
			},
			deleteRoomDialog: {
				title: "Excluir Sala",
				message: "Deseja excluir a sala",
			},
			createOrEdit: {
				title: {
					new: "Novo Sala",
					edit: "Editar Sala",
				},
				fields : {
					nick: "Nick",
					name: "Nome",
					description: "Descrição",
					positionRoom: "Posição da Sala",
					url: "URL",
					imageTitle: "Imagem",
					capacity: "Capacidade",
				},
				sections: {
					data: "Dados",
					specifications: "Especificações",
				},
				buttons: {
					save: "Salvar",
					back: "Voltar",
				},
				errors: {
					imageNotFound: "É preciso de uma imagem para salvar a sala",
				},
			},
		},
		bedrooms: {
			title: "Quartos",
			table: {
				header: {
					picture: "Foto",
					nick: "Nick",
					name: "Nome",
					description: "Descrição",
					size: "Tamanho",
					capacity: "Capacidade",
				},
				tableIsEmpty: "Não foi possivel encontrar mais quartos",
			},
			createOrEdit: {
				title: {
					new: "Novo Quarto",
					edit: "Editar Quarto",
				},
				nick: "Nick",
				name: "Nome",
				description: "Descrição",
				positionBedroom: "Posição do Quarto",
				externalUrl: "Url externa",
				size: "Tamanho",
				capacity: "Capacidade",
				imagesTitle: "Imagens",
				sections: {
					data: "Dados",
					specifications: {
						title: "Especificações",
						add: "Adicionar Especificação",
						type: "Tipo",
						description: "Descrição",
						cancel: "Cancelar",
						deleteAlert: {
							title: "Remover Especificação",
							message: "Você deseja realmente remover essa especificação?",
						},
						errors: {
							emptyDescription: "A descrição não pode ficar vazia.",
							fullBedroomSpecifications: "Você não pode adiconar mais que 10 Especificações no mesmo quarto.",
						},
					},
				},
				buttons: {
					add: "Adicionar",
					save: "Salvar",
					back: "Voltar",
				},
			},
			deleteBedroomDialog: {
				title: "Excluir Quarto",
				message: "Deseja excluir o quarto",
			},
		},
		surveys: {
			title: "Avaliações",
			answer: {
				name: "Nome",
				email: "Email",
				phone: "Telefone",
				nps: {
					title: "NPS",
					description: "De 0 a 10 quanto as pessoas indicam a seu hotel.",
				},
				average: "Média",
				comment: "Comentário",
				buttons: {
					back: "Voltar",
				},
			},
			stats: {
				averageNps: {
					title: "NPS",
					description: "De 0 a 10 quanto as pessoas indicam a seu hotel.",
				},
				averageRate: {
					title: "Média",
					description: "Média de todas as perguntas realizadas.",
				} ,
				forEachQuestion: "Para cada pergunta a média de nota de seus clientes",
			},
			avaliationsIsEmpty: "Ainda não foi feita nenhuma avaliação para este Hotel",
			table: {
				header: {
					name: "Nome",
					email: "Email",
					nps: "NPS",
					average: "Média",
				},
				tableIsEmpty: "Não foi possivel encontrar mais avaliações",
			},
		},
		enum: {
			GastroPlaceType: {
				bar: "Bar",
				restaurant: "Restaurante",
			},
			Language: {
				ptBr: "Português",
				enUs: "Inglês",
				esEs: "Espanhol",
			},
			BedroomConfort: {
				bed: "Cama",
				airConditioning: "Ar-condicionado",
				safe: "Cofre",
				minibar: "Minibar",
				tv: "TV",
				view: "Vista",
				bath: "Banheira",
				size: "Tamanho",
				roomService: "Serviço de quarto",
				diningRoom: "Sala de jantar",
				pillows: "Travesseiros",
				layette: "Enxoval",
				wifi: "Wi-fi",
				livingRoom: "Sala de estar",
				alarm: "Alarme",
			},
		},
	},
});

api.setStrings(strings);
export default strings;
